import React, { useState } from 'react';
import './ForgotPasswordPopup.css';

interface ForgotPasswordPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSendCode: (username: string) => Promise<{ success: boolean; email?: string; message?: string }>;
  onShowResetPopup: (username: string, email: string) => void;
  onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
  onBackToLogin?: () => void;
}

const ForgotPasswordPopup: React.FC<ForgotPasswordPopupProps> = ({
  isOpen,
  onClose,
  onSendCode,
  onShowResetPopup,
  onShowToast,
  onBackToLogin,
}) => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!username.trim()) {
      setError('Vui lòng nhập tên đăng nhập');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const result = await onSendCode(username);
      if (result.success && result.email) {
        onShowToast('Mã xác thực đã được gửi đến email của bạn', 'success');
        // Hiển thị popup nhập pin + password mới
        onShowResetPopup(username, result.email);
        handleClose();
      } else {
        setError(result.message || 'Có lỗi xảy ra khi gửi mã xác thực');
      }
    } catch (err) {
      console.error('[ForgotPasswordPopup] Error sending code:', err);
      setError('Có lỗi xảy ra khi gửi mã xác thực');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setUsername('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="forgot-password-overlay" onClick={handleClose}>
      <div className="forgot-password-popup" onClick={(e) => e.stopPropagation()}>
        <div className="forgot-password-header">
          <h2 className="forgot-password-title">Quên mật khẩu</h2>
          <div className="forgot-password-header-actions">
            <button
              type="button"
              className="forgot-password-back-btn"
              onClick={() => {
                // Close forgot popup and call parent to open login popup
                setUsername('');
                setError('');
                onClose();
                if (typeof onBackToLogin === 'function') onBackToLogin();
              }}
            >
              Quay lại đăng nhập
            </button>
            <button className="forgot-password-close-btn" onClick={handleClose}>
              ×
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          <div className="form-group">
            <label htmlFor="forgot-username">Tên đăng nhập</label>
            <input
              type="text"
              id="forgot-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Nhập tên đăng nhập của bạn"
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="forgot-password-submit-btn" disabled={loading}>
            {loading ? 'Đang gửi...' : 'Gửi mã xác thực'}
          </button>
        </form>

        <p className="forgot-password-info">
          Chúng tôi sẽ gửi mã xác thực đến email liên kết với tài khoản của bạn.
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPopup;
